import React from "react";
import DateSelector from "elements/DateSelector";
import { __ } from "services/Translator";

/**
 * Start / end date filters for transaction & gaming history.
 */
export default function HistoryDateRange({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  startYear,
  endYear,
  useMobilePicker,
}) {
  return (
    <div className="col-12 history-filters__dates-row">
      <div className="history-filters__date-range">
        <div className="history-filters__date-field">
          <div className="input_item history-filters__date-input">
            <label className="name">
              <i className="far fa-calendar-alt" aria-hidden="true" /> {__("From")}
            </label>
            <DateSelector
              value={startDate}
              onChange={onStartChange}
              startYear={startYear}
              endYear={endYear}
              useMobilePicker={useMobilePicker}
              placeholder={__("Any date")}
            />
          </div>
        </div>
        <div className="history-filters__date-field">
          <div className="input_item history-filters__date-input">
            <label className="name">
              <i className="far fa-calendar-alt" aria-hidden="true" /> {__("To")}
            </label>
            <DateSelector
              value={endDate}
              onChange={onEndChange}
              startYear={startYear}
              endYear={endYear}
              useMobilePicker={useMobilePicker}
              placeholder={__("Any date")}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
